import React from "react";
import { PhytoViewType } from "modules/common";
import PhytoViewZupanijaModal from "./modals/PhytoViewZupanijaModal";
import PhytoViewJLSModal from "./modals/PhytoViewJLSModal";
import PhytoViewGospodarskeJediniceModal from "./modals/PhytoViewGospodarskeJediniceModal";
import PhytoViewSOPodkategorijeModal from "./modals/PhytoViewSOPodkategorijeModal";
import PhytoViewSOKultureModal from "./modals/PhytoViewSOKultureModal";
import PhytoViewFenofazePodkategorijeModal from "./modals/PhytoViewFenofazePodkategorijeModal";
import PhytoViewFenofazeKultureModal from "./modals/PhytoViewFenofazeKultureModal";
import PhytoViewSOAtributVrsteModal from "./modals/PhytoViewSOAtributVrsteModal";
import PhytoViewFenofazeSorteModal from "./modals/PhytoViewFenofazeSorteModal";
import PhytoViewSOVrstaModal from "./modals/PhytoViewSOVrstaModal";
import PhytoViewSOTipModal from "./modals/PhytoViewSOTipModal";
import PhytoViewProstorUzgojaModal from "./modals/PhytoViewProstorUzgojaModal";
import PhytoViewSOAtributPodskupaVrsteModal from "./modals/PhytoViewSOAtributPodskupaVrsteModal";
import PhytoViewFenofazeModal from "./modals/PhytoViewFenofazeModal";
import PhytoViewFenofazePodfazeModal from "./modals/PhytoViewFenofazePodfazeModal";
interface Props {
    selectedOption: PhytoViewType;
    isPost: boolean;
    isModalOpen: boolean;
    editItemId: number | null;
    onClose: () => void;
}

const PhytoViewSelectModal: React.FC<Props> = ({
    selectedOption,
    isPost,
    isModalOpen,
    editItemId,
    onClose,
}) => {
    switch (selectedOption) {
        case PhytoViewType.County:
            return (
                <PhytoViewZupanijaModal
                    title={isPost ? "Dodaj novu županiju" : "Izmijeni postojeću županiju"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId}
                />
            );

        case PhytoViewType.JLS:
            return (
                <PhytoViewJLSModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId}
                />
            );

        case PhytoViewType.EconomicUnits:
            return (
                <PhytoViewGospodarskeJediniceModal
                    title={
                        isPost
                            ? "Dodaj novu gospodarsku jedinicu"
                            : "Izmijeni postojeću gospodarsku jedinicu"
                    }
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId}
                />
            );
        case PhytoViewType.HarmfulOrganismsSubCategories:
            return (
                <PhytoViewSOPodkategorijeModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.HarmfulOrganismsCultures:
            return (
                <PhytoViewSOKultureModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubCategories:
            return (
                <PhytoViewFenofazePodkategorijeModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.PhasesOfPlantGrowthAndDevelopmentCultures:
            return (
                <PhytoViewFenofazeKultureModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSorts:
            return (
                <PhytoViewFenofazeSorteModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.HarmfulOrganismsSpecies:
            return (
                <PhytoViewSOVrstaModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.HarmfulOrganismsType:
            return (
                <PhytoViewSOTipModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.CultivationArea:
            return (
                <PhytoViewProstorUzgojaModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.HarmfulOrganismsAttributesOfTheTypepOfHarmfulOrganism:
            return (
                <PhytoViewSOAtributVrsteModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.HarmfulOrganismsAttributesOfASubsetOfTheTypeOfHarmfulOrganism:
            return (
                <PhytoViewSOAtributPodskupaVrsteModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
        case PhytoViewType.PhasesOfPlantGrowthAndDevelopmentTheMainPhases:
            return (
                <PhytoViewFenofazeModal
                    title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                    isOpen={isModalOpen}
                    onClose={onClose}
                    isPost={isPost}
                    editItemId={editItemId!}
                />
            );
            case PhytoViewType.PhasesOfPlantGrowthAndDevelopmentSubphases:
                return (
                    <PhytoViewFenofazePodfazeModal
                        title={isPost ? "Dodaj novi unos" : "Izmijeni postojeći unos"}
                        isOpen={isModalOpen}
                        onClose={onClose}
                        isPost={isPost}
                        editItemId={editItemId!}
                    />
                );
        default:
            return null;
    }
};

export default PhytoViewSelectModal;
